module.exports = __webpack_public_path__ + "img/camera_tall.1ba2b8c9.jpg";